// extracted by mini-css-extract-plugin
export default {"container":"RJ-z","dimension":"SJ-z","dimensionLabels":"TJ-z"};